
export const BRAND_COLORS = {
  primary: '#37559e',
  accent: '#F7B230'
};

export const NEUTRAL_COLORS = {
  white: '#ffffff',
  black: '#000000'
};

export const SYSTEM_COLORS = {
  shellBackground: '#f4f7fb',
  shellSurface: '#ffffff',
  shellSurfaceMuted: '#eef3fb',
  shellOverlay: 'rgba(15, 23, 42, 0.45)',
  navSurface: '#314b8a',
  navSurfaceHover: 'rgba(255, 255, 255, 0.08)',
  navSurfaceActive: 'rgba(255, 255, 255, 0.16)',
  navText: 'rgba(255, 255, 255, 0.92)',
  navTextMuted: 'rgba(255, 255, 255, 0.74)',
  divider: '#e2e8f0',
  border: '#d1d5db',
  borderSoft: '#e5e7eb',
  surfaceMuted: '#f3f4f6',
  surfaceSubtle: '#f9fafb',
  textMuted: '#4b5563',
  textSoft: '#64748b',
  textOnBrandStrong: 'rgba(255, 255, 255, 0.9)',
  textOnBrandMedium: 'rgba(255, 255, 255, 0.88)',
  textOnBrandSoft: 'rgba(255, 255, 255, 0.78)',
  borderOnBrand: 'rgba(255, 255, 255, 0.3)',
  primaryRing: 'rgba(55, 85, 158, 0.2)',
  primaryTint: '#bfdbfe',
  accentTint: '#e7b7a4',
  success: '#15803d',
  successTint: '#dcfce7',
  warning: '#b45309',
  warningTint: '#fef3c7',
  danger: '#b91c1c',
  dangerTint: '#fee2e2',
  info: '#1d4ed8',
  infoTint: '#dbeafe',
  shadowSoft: '0 12px 30px rgba(15, 23, 42, 0.06)',
  shadowStrong: '0 24px 60px rgba(15, 23, 42, 0.14)'
};
